const C = require("../constants");

const productPricesDialog = (data) => {
    return {
        type: C.PRODUCT_PRICES_DIALOG,
        data
    }
};

export {productPricesDialog};


// WEBPACK FOOTER //
// ./src/actions/ProductPricesDialogActions.js